import {SMALL} from './BreakPoints.js'
/*
    Responsive props to hold all the props relevant for device info and layout
    Immediate extension with spacing for Desktop and mobile
*/
export const responsiveProps = {

    isMobile: {
        default: false,
        [SMALL]: true
    },

    headerFont: {
        default: "h200",
        [SMALL]: "b200"
    },

    textFont: {
        default: "b300",
        [SMALL]: "b100"
    },

    spacingInset_shorthand2: {
        default: "none large",
        [SMALL]: "none medium",
    },

    spacingInset_shorthand3: {
        default: "large",
        [SMALL]: "small small none small",
    }
}


// WEBPACK FOOTER //
// ./src/components/common/constant/ResponsiveProps.js